export default class Locale_ListBulkEditor { 
	PropertiesToEdit: string = "Here you can select which properties to edit. The selected properties will be overridden on all the selected items.";
}